import { SubNav } from "@/components/SubNav"

/**
 * The Travel Tracker's tab strip.
 *
 * The two read-only views come first and the Tracker last, and the sidebar entry
 * points at Summary to agree with that.
 *
 * Every tab is shown to everyone who can see this component at all, because the
 * whole module is IUPAT-only — unlike BumpTrainingSubNav, which hides its Summary
 * because its tracker is open to every user. All three travel controllers include
 * RequiresIupat, so a District Council user never reaches any of these pages to be
 * offered a tab in the first place.
 *
 * All three pass an explicit `active` predicate: "/travel_tracker" is a prefix of
 * both other paths, so the default match would light Tracker on every page.
 *
 * No OrgSwitcher in the right-hand slot. The tracker is personal and the
 * summaries are union-wide — neither changes with the organization being viewed.
 */
export function TravelTrackerSubNav() {
  const items = [
    {
      href: "/travel_tracker/summary",
      label: "Summary",
      active: (url: string) => url.startsWith("/travel_tracker/summary"),
    },
    {
      href: "/travel_tracker/locations",
      label: "Location Summary",
      active: (url: string) => url.startsWith("/travel_tracker/locations"),
    },
    {
      href: "/travel_tracker",
      label: "Tracker",
      active: (url: string) =>
        url === "/travel_tracker" || url.startsWith("/travel_tracker?"),
    },
  ]

  return <SubNav ariaLabel="Travel Tracker sections" items={items} />
}
